import { DEFAULT_LOGIN_REDIRECT } from '@/routes';
import { signIn, signOut } from 'next-auth/react';
import Link from 'next/link';
import { useSearchParams } from 'next/navigation';

import {
    GoogleIcon,
    HubspotIcon,
    OktaIcon,
} from '@/components/icon-collection';
import { Button } from '@/components/ui/button';

export const LoginButton = () => {
    const searchParams = useSearchParams();
    const callbackUrl = searchParams.get('callbackUrl');

    return (
        <button
            onClick={() =>
                signIn('hubspot', {
                    callbackUrl: callbackUrl || DEFAULT_LOGIN_REDIRECT,
                })
            }
            className={'rounded-2xl bg-gray-400/50 px-5 py-3'}
        >
            Sign in
        </button>
    );
};

export const RegisterButton = () => {
    return (
        <Link
            href={'/auth/register'}
            className={'rounded-2xl bg-gray-400/50 px-5 py-3'}
        >
            Register
        </Link>
    );
};

export const LogoutButton = () => {
    return (
        <button
            onClick={() => signOut()}
            className={'rounded-2xl bg-gray-400/50 px-5 py-3'}
        >
            Sign Out
        </button>
    );
};

export function GoogleSignInButton({
    children,
    disabled,
}: {
    children: React.ReactNode;
    disabled?: boolean;
}) {
    const searchParams = useSearchParams();
    const callbackUrl = searchParams.get('callbackUrl');

    const loginWithGoogle = () => {
        signIn('google', {
            callbackUrl: callbackUrl || DEFAULT_LOGIN_REDIRECT,
        });
    };

    return (
        <Button
            variant="outline"
            className="w-full flex items-center justify-center"
            onClick={loginWithGoogle}
            disabled={disabled}
        >
            <GoogleIcon />
            {/* <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                <path
                    d="M12.48 10.92v3.28h7.84c-.24 1.84-.853 3.187-1.787 4.133-1.147 1.147-2.933 2.4-6.053 2.4-4.827 0-8.6-3.893-8.6-8.72s3.773-8.72 8.6-8.72c2.6 0 4.507 1.027 5.907 2.347l2.307-2.307C18.747 1.44 16.133 0 12.48 0 5.867 0 .307 5.387.307 12s5.56 12 12.173 12c3.573 0 6.267-1.173 8.373-3.36 2.16-2.16 2.84-5.213 2.84-7.667 0-.76-.053-1.467-.173-2.053H12.48z"
                    fill="currentColor"
                />
            </svg> */}

            {children}
        </Button>
    );
}

export function HubspotSignInButton({
    children,
    disabled,
}: {
    children: React.ReactNode;
    disabled?: boolean;
}) {
    const loginWithHubspot = () => {
        signIn('hubspot');
    };

    return (
        <Button
            variant="outline"
            className="relative flex w-full items-center justify-center bg-slate-50 dark:border-muted-foreground dark:text-muted-foreground"
            onClick={loginWithHubspot}
            disabled={disabled}
        >
            <HubspotIcon className="mr-1 h-4 w-4" />
            <span className="grow text-center">{children}</span>
        </Button>
    );
}

export function OktaSignInButton({
    children,
    disabled,
}: {
    children: React.ReactNode;
    disabled?: boolean;
}) {
    const loginWithOkta = () => {
        signIn('okta');
    };

    return (
        <Button
            variant="outline"
            className="relative flex w-full items-center justify-center bg-slate-50 dark:border-muted-foreground dark:text-muted-foreground"
            onClick={loginWithOkta}
            disabled={disabled}
        >
            <OktaIcon className="mr-1 h-4 w-4" />
            <span className="grow text-center">{children}</span>
        </Button>
    );
}
